'use strict';
import * as tools from './tools.js';

window.$ = window.jQuery = require('jquery');
window.Popper = require('@popperjs/core');
window.bootstrap = require('bootstrap');

import lazyframe from "lazyframe";
lazyframe(".lazyframe", {
    autoplay: true,
});

import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiperhome = new Swiper('.swiper__home', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 1,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
  pagination: {
      el: '.swiper-pagination',
  },
  on: {
      init: function () {
          let headerHeight = document.querySelector('header').offsetHeight;
          this.el.style.height = (innerHeight - headerHeight) + 'px';
          tools.pauseSliderVideos(this);
          tools.playSliderVideos(this);
      },
      transitionStart: function(){
          tools.pauseSliderVideos(this);
      },
      transitionEnd: function(){
          tools.playSliderVideos(this);
      },
  },
});

const swiper = new Swiper('.swiper__full', {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    },
    on: {
        init: function () {
            let headerHeight = document.querySelector('header').offsetHeight;
            this.el.style.height = (innerHeight - headerHeight) + 'px';
            tools.pauseSliderVideos(this);
            tools.playSliderVideos(this);
        },
        transitionStart: function(){
            tools.pauseSliderVideos(this);
        },
        transitionEnd: function(){
            tools.playSliderVideos(this);
        },
    },
});

const swiperHomeProductos  = new Swiper('.swiper__home_productos', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints : {
        600: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 6,
            spaceBetween: 30
        },
    },
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const swiperHomeSectores  = new Swiper('.swiper__home_casos', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints : {
      768: {
          slidesPerView: 2,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 3,
          spaceBetween: 30
      },
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});

const swiperHomeServicios  = new Swiper('.swiper__home_servicios', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints : {
      600: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      768: {
          slidesPerView: 3,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 4,
          spaceBetween: 30
      },
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});

const swiperHomeNoticias  = new Swiper('.swiper__home_noticias', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints : {
      650: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      768: {
          slidesPerView: 2,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 3,
          spaceBetween: 30
      },
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});

const swiperProveedores  = new Swiper('.swiper-proveedores', {
  modules: [Navigation, Autoplay],
  slidesPerView: 1,
  spaceBetween: 0,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints : {
      650: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      768: {
          slidesPerView: 2,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 3,
          spaceBetween: 30
      },
  },
  navigation : {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting){
      entry.target.classList.add('show');
    } else{
      entry.target.classList.remove('show');
    }
  });
});

const hiddenElements = document.querySelectorAll('.hidden');
hiddenElements.forEach((el) => observer.observe(el));

$('.counting').each(function() {
  var $this = $(this),
      countTo = $this.attr('data-count');
  $({ countNum: $this.text()}).animate({
    countNum: countTo
  },

  {
    duration: 3000,
    easing:'linear',
    step: function() {
      $this.text(Math.floor(this.countNum).toLocaleString('de-DE'));
    },
    complete: function() {
      $this.text(this.countNum.toLocaleString('de-DE'));
      //alert('finished');
    }

  });  
});

$(document).ready(function () {
  var mySwiper = new Swiper(".swiperhistoria", {
    autoHeight: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    speed: 500,
    direction: "horizontal",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination"
    },
    loop: false,
    effect: "slide",
    spaceBetween: 30,
    on: {
      init: function () {
        $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
        $(".swiper-pagination-custom .swiper-pagination-switch").eq(0).addClass("active");
      },
      slideChangeTransitionStart: function () {
        $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
        $(".swiper-pagination-custom .swiper-pagination-switch").eq(mySwiper.realIndex).addClass("active");
      }
    }
  });
  $(".swiper-pagination-custom .swiper-pagination-switch").click(function () {
    mySwiper.slideTo($(this).index());
    $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
    $(this).addClass("active");
  });

  let categoryLink = document.querySelectorAll('.new-category');
  if(categoryLink.length > 0){
      categoryLink.forEach((element) => {
          element.addEventListener('click',(event) => {
              event.preventDefault();
              event.stopPropagation();
              location.href = element.dataset.href;
          })
      })
  }

});
